import { useQueryClient } from '@tanstack/react-query'
import { useApiRequestMutation } from '@/hooks/use-api'
import { useToast } from '@/hooks/use-toast'
import { useTranslation } from '@/hooks/use-translation'
import { setTabOrganizationId } from '@/lib/tab-organization'

export function useSwitchOrganization() {
  const queryClient = useQueryClient()
  const { error } = useToast()
  const t = useTranslation()

  // Full-page redirect on success (clears all client state) — intentionally uses
  // onSuccess with window.location instead of React Router navigate
  const mutation = useApiRequestMutation(
    (organizationId: string) => ({
      method: 'post' as const,
      url: '/super-admin/switch-organization',
      data: { organizationId },
    }),
    {
      onSuccess: (_response, organizationId) => {
        setTabOrganizationId(organizationId)
        queryClient.clear()
        window.location.href = '/'
      },
      onError: () => {
        error(t('superAdmin.toasts.organizationSwitchError'))
      },
    },
  )

  return {
    switchOrganization: mutation.mutateAsync,
    isSwitching: mutation.isPending,
  }
}
